/*
* Project: LegalPlace assistant
* File: src\components\misc\list.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { generateId1 } from '../utils/misc';
import {
  initOutputVariable, editVariable, initOutputOption,
} from '../../redux/actions/output';
import { firedFlat } from '../../middlewares/logging';

// importing more componentns
import LpHelper from './helper';
import LpPopupPreview from '../popup_preview';
import { lpGetOptionById, lpGetVariableById, updateConditions } from '../../logic/re_index';
import { icSetOption, icSetVariable } from '../../redux/actions/input_context';
import { editedDocument } from '../../redux/actions/account_settings';
import { isDocumentEdited } from '../../globals';
import LpWarning from './warning';
import lpApp from '../../app/lp_app';


class ListComponent extends Component {
  constructor(props) {
    super(props);
    this.params = {
      ...props,
    };
    this.lpKey = generateId1(4);
    this.selectCallback = this.selectCallback.bind(this);
    if (props.isDuplicate) {
      this.params.id = `${this.params.id}_${props.copy}`;
    }
  }

  componentWillMount() {
    // console.log("cpas");
    if (!this.props.exists) {
      const id = this.props.copy === -2 ? this.props.id : `${this.props.id}_${this.props.copy}`;
      const { value } = lpApp.indexes.variables.getVariable(id);
      this.props.initializeFlat(this.props.lpKey, this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, this.props.ovc, this.props.sectionId, this.props.group);
      this.props.initOutputSystem(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, this.props.lpKey, this.props.ovc, value);
    } else {
      this.params.label = lpApp.references.getVariable(this.props.id);
    }
    // load list components, and label
    if ('list' in lpApp.references.getVariable(this.props.id)) this.listValue = lpApp.references.getVariable(this.props.id).list;
  }

  selectCallback(evt) {
    // console.log("Selected " + evt.target.value)
    this.props.changeValue(this.props.isDuplicate ? `${this.props.id}_${this.props.copy}` : this.props.id, evt.target.value);
    lpApp.action_tracker.trackAction('EDIT_VARIABLE', this.props.id);
    updateConditions();
    this.forceUpdate();
    this.props.unUpdateContext();
  }

  // TODO: Add the possibility to add one single flat_key

  render() {
    return (
      <div className="form-group" data-type="list" data-id={this.props.id} data-is-duplicate={this.props.isDuplicate} data-copy={this.props.copy}>
        <label htmlFor={`list_${this.props.lpKey}`}>
          {this.props.label}
          {' '}
          {'helper' in lpApp.references.getVariable(this.props.id) && lpApp.references.getVariable(this.props.id).helper.length > 0 && <LpHelper text={lpApp.references.getVariable(this.props.id).helper} />}
        </label>
        {(this.props.id in lpApp.references.variables) && lpApp.references.getVariable(this.props.id).warning && <LpWarning text={lpApp.references.getVariable(this.props.id).warning} id={this.props.id} type="v" />}
        <select
          id={`list_${this.props.lpKey}`}
          onChange={this.selectCallback}
          onFocus={this.props.updateContext}
          onBlur={this.props.unUpdateContext}
          className="form-control"
          value={this.props.value}
        >
          <option value="" />
          {this.listValue.map((idx) => {
            if (idx === this.props.value) {
              return (
                <option key={generateId1(2)} value={idx}>
                  {' '}
                  {idx}
                  {' '}
                </option>
              );
            }
            return (<option key={generateId1(2)} value={idx}>{idx}</option>);
          })}
        </select>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // the thing
  let checked = false;
  let exists = false;
  let existsKey = '';
  let existsParent = '';
  let cId = ownProps.id;
  if (ownProps.isDuplicate) cId = `${ownProps.id}_${ownProps.copy}`;
  if (ownProps.ovc === 'o') {
    const opt = lpGetOptionById(cId);
    if (opt) {
      existsKey = opt.key;
      exists = true;
      checked = opt.value;
    }
  } else
  if (ownProps.ovc === 'v') {
    const vars = lpGetVariableById(cId);
    if (vars) {
      existsKey = vars.key;
      exists = true;
      checked = vars.value;
    }
  }
  state.flat.forEach((idx) => {
    if (exists) if (idx.uiid === existsKey) existsParent = idx.parentUi;
  });
  firedFlat();
  return {
    // exists: checkUIExists(state.flat, ownProps.id, ownProps.genre),
    sectionId: state.contract.currentSection,
    value: checked,
    exists,
    existant_key: existsKey,
    existant_parent: existsParent,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  initializeFlat: (uiid, id, genre, sectionId, parentId, parentUi, isDuplicate, copy) => {
    const cId = !isDuplicate ? id : `${id}_${copy}`;
    if (!ownProps.exists) {
      if (genre === 'o') dispatch(initOutputOption(cId, uiid, ''));
      else if (genre === 'v') dispatch(initOutputVariable(cId, uiid, ''));
    }
  },
  initOutputSystem: (id, parent, genre, value, isDuplicate, copy) => {
    // console.log(genre);
    // check duplication
    const cId = !isDuplicate ? id : `${id}_${copy}`;
    const cPid = !isDuplicate ? parent : `${parent}_${copy}`;

    if (genre === 'o') dispatch(initOutputOption(cId, cPid, value));
    else if (genre === 'v') dispatch(initOutputVariable(cId, cPid, value));
  },
  changeValue: (id, value) => {
    // let cId = !isDuplicate ? id : id + '_' + copy;
    // let cPid = !isDuplicate ? parent : parent + '_' + copy;
    dispatch(editVariable(id, value));
    if (!isDocumentEdited()) dispatch(editedDocument(true));
  },
  updateContext: () => {
    const cId = ownProps.isDuplicate ? `${ownProps.id}_${ownProps.copy}` : ownProps.id;
    const pId = ownProps.isDuplicate ? `${ownProps.parent}_${ownProps.copy}` : ownProps.parent;
    if (ownProps.ovc === 'o') dispatch(icSetOption(cId));
    else {
      dispatch(icSetVariable(cId));
      dispatch(icSetOption(pId));
    }
  },
  unUpdateContext: () => {
    if (ownProps.ovc === 'o') dispatch(icSetOption(''));
    else {
      dispatch(icSetVariable(''));
      dispatch(icSetOption(''));
    }
  },
});
const LpList = connect(mapStateToProps, mapDispatchToProps)(ListComponent);

export default LpList;



// WEBPACK FOOTER //
// ./src/components/misc/list.js